import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { SpPaymentMethodSignalComponent } from '@components/sp-payment-method-signal';

import type { PaymentMethod } from '@integrations/payment-methods';
import type { PaymentElementLegacy } from '@sites/entity-core';
import type { PaymentFormWidgetForm } from '@sites/entity-signal-form';

import { WebSettingsModule } from '@web/shared/components/web-settings/web-settings.module';
import { FormSettingsPanel } from '@web/widgets/common/abstract/form-settings-panel';

/**
 * Breadcrumbs/footer chrome around `sp-payment-method-signal`, editing one
 * element of the payment-form's `paymentElements` array in place
 * (`form.updatePaymentElement(index, …)`). Save/cancel and the transaction
 * frame come from `FormSettingsPanel`.
 */
@Component({
    selector: 'web-payment-method-settings',
    templateUrl: './payment-method-settings.component.html',
    styleUrls: ['./payment-method-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [WebSettingsModule, SpPaymentMethodSignalComponent, TranslateModule],
})
export class PaymentMethodSettingsComponent extends FormSettingsPanel<PaymentFormWidgetForm> {
    public readonly paymentMethods = input.required<PaymentMethod[]>();
    public readonly index = input.required<number>();

    public readonly paymentElements = computed<PaymentElementLegacy[]>(() => this.form().paymentElements().value());
    /** The signal-form tree node the child binds onto — edits write straight into the host form. */
    public readonly paymentElementField = computed(() => this.form().paymentElementAt(this.index()));

    public readonly isSaveDisabled = signal<boolean>(false);

    public override get saveDisablePredicate(): boolean {
        return this.isSaveDisabled();
    }
}
